module.exports = __webpack_public_path__ + "static/bluegold-1d2b939a998865a45def7dec7214fb46.gif";